import { Record, Map as ImmutableMap } from 'immutable';
import { STATIC_VALUE } from 'automation-ui-flow-core/fields/PropertyValueTypes';
import * as DateMetadataKeys from 'automation-ui-action-features/time/DateMetadataKeys';
export default class StaticDate extends Record({
  [DateMetadataKeys.TYPE]: STATIC_VALUE,
  [DateMetadataKeys.VALUE]: null
}, 'StaticDate') {
  constructor(props) {
    const propMap = ImmutableMap(props || {});
    const value = Number(propMap.get(DateMetadataKeys.VALUE)) || null;
    super(propMap.set(DateMetadataKeys.VALUE, value));
  }
  getType() {
    return this.get(DateMetadataKeys.TYPE);
  }
  getValue() {
    return this.get(DateMetadataKeys.VALUE);
  }
  setValue(value) {
    return this.set(DateMetadataKeys.VALUE, value);
  }
}